import * as React from 'react'
import { FieldProps } from 'formik'
import FormControl from '@mui/material/FormControl'
import RadioGroup, { RadioGroupProps } from '@mui/material/RadioGroup'
import Radio, { RadioProps } from '@mui/material/Radio'
import FormControlLabel, {
  FormControlLabelProps,
} from '@mui/material/FormControlLabel'

interface Props extends FieldProps, Omit<RadioGroupProps, 'name' | 'value'> {
  label: string
  disabled: boolean
  options: { label: string; value: string }[]
  radioProps?: RadioProps
  radioLabelProps?: Omit<FormControlLabelProps, 'label' | 'value' | 'control'>
  labelClassName?: string
}

export const MuiRadioGroupFormik: React.FC<Props> = ({
  label,
  options,
  field,
  form: { isSubmitting, isValidating },
  disabled = isSubmitting || isValidating,
  radioProps,
  radioLabelProps,
  labelClassName,
  ...props
}) => (
  <FormControl component="fieldset">
    <legend className={labelClassName}>{label}</legend>
    <RadioGroup {...props} {...field}>
      {options.map(({ label, value }, i) => (
        <FormControlLabel
          key={i}
          label={label}
          value={value}
          control={<Radio {...radioProps} disabled={disabled} />}
          {...radioLabelProps}
        />
      ))}
    </RadioGroup>
  </FormControl>
)
